// extracted by mini-css-extract-plugin
export default {"skusLegend":"barchartfooter_skusLegend__rmwvF","skuRevenue":"barchartfooter_skuRevenue__EEasF","skuGrowth":"barchartfooter_skuGrowth__iQx1S","footer":"barchartfooter_footer__Y0R-Q"};